// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"87d4a399","794":"0b3fd870","3710":"f02194a7","4673":"c3590146","8177":"6abef056","8503":"32266728","8688":"6a7ad95e","8860":"09022faf"}[chunkId] + ".chunk.css";
};